export const fileExtension = (fileName: string) => {
  const extensionStart = fileName.lastIndexOf('.');

  return extensionStart > 0
    ? fileName.slice(extensionStart + 1).toLowerCase()
    : '';
};
